
    import "src/app/AppSeller/SettingsPage/ShippingPackages/index.module.scss?farm_css_modules";
    
    export default {"addButton": `addButton-ff58cbcd`,"flexCenter": `flexCenter-ff58cbcd`,"main": `main-ff58cbcd`,"searchContainer": `searchContainer-ff58cbcd`,"searchInput": `searchInput-ff58cbcd`,"topFilter": `topFilter-ff58cbcd`,"topLeftFilter": `topLeftFilter-ff58cbcd`,"topRightFilter": `topRightFilter-ff58cbcd`}
    